import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, inject } from '@angular/core';
import { InputItemType } from '@src/app/modules/search-cities';
import { BaseResizableComponent } from '@src/app/modules/base';
import { APP_CONFIG } from '@src/core';
import { PreferencesService } from '@src/core/services';

import { LoyaltyProgramPermService } from '../../services';
import { LoyaltyProgramFilterData } from '../../types';

@Component({
  selector: 'lp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent extends BaseResizableComponent {
  public readonly permService = inject(LoyaltyProgramPermService);
  private readonly preferencesService = inject(PreferencesService);

  @Output() add = new EventEmitter();

  @Input() search: string = '';
  @Output() searchChange = new EventEmitter<string>();

  @Input() city?: InputItemType;
  @Output() cityChange = new EventEmitter<InputItemType>();

  @Output() applyFilterAndChangeRoute = new EventEmitter<LoyaltyProgramFilterData>();

  get isLogoVisible() {
    if (this.isDesktop) {
      return this.permService.showOnlyLoyaltyProgram;
    }

    return this.preferencesService.settings$.value?.showOnlyLoyaltyProgram || APP_CONFIG.isBrand;
  }
}
